import React from 'react';
import { motion } from 'framer-motion';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  className?: string;
  onClick?: () => void;
}
export const Button: React.FC<ButtonProps> = ({
  children,
  className = '',
  onClick,
  ...props
}) => {
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} onClick={onClick} className={`bg-gold hover:bg-gold-hover text-navy font-semibold py-4 px-8 rounded-lg shadow-lg transition-colors duration-300 text-lg sm:text-xl w-full sm:w-auto ${className}`} {...props} data-id="element-148">
      {children}
    </motion.button>;
};